import { provideZoneChangeDetection } from '@angular/core';

import { bootstrapApplication } from '@angular/platform-browser';
import { noop } from 'rxjs';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

document.addEventListener('DOMContentLoaded', () => {
    bootstrapApplication(AppComponent, {
        ...appConfig,
        providers: [provideZoneChangeDetection(), ...appConfig.providers]
    }).catch(noop);
});
